const MENU_ITEMS = [
  { id: 1, name: 'LATEST', link: '/kickavenews/latest' },
  // { id: 2, name: 'FEATURES', link: '/kickavenews#features' },
  // { id: 3, name: 'POPULAR', link: '/kickavenews#popular' },
  // { id: 4, name: 'LOCAL SCENE', link: '/kickavenews#local-scene' },
  { id: 5, name: 'CALENDAR', link: '/kickavenews/calendar' },
];

export function useMenuItem() {
  return MENU_ITEMS;
}